import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import {
  LoadingController,
  AlertController,
  Events,
  NavController,
  ToastController
} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class CommonUtilitiesService {
  isLoading = false;
  constructor(
    public http: Http,
    public loadingCtrl: LoadingController,
    public alertController: AlertController,
    public events: Events,
    public navCtrl: NavController,
    public toastController: ToastController
  ) { }

  async presentLoding(messageDispaly) {
    this.isLoading = true;
    return await this.loadingCtrl.create({
      // duration: 6000,
      message: '',
      spinner: 'lines',
      cssClass: 'transparent'
    }).then(a => {
      a.present().then(() => {
        if (!this.isLoading) {
          // a.dismiss().then(() => console.log('abort presenting: ' + messageDispaly));
          a.dismiss().then(() => '');
        }
      });
    });
  }

  async dismiss() {
    this.isLoading = false;
    return await this.loadingCtrl.dismiss();
    // return await this.loadingCtrl.dismiss().then(() => console.log('dismissed: ' + mNo));
  }

  async presentToastWithOptions(isButton, txtMessage, txtHeader) {
    if (!isButton) {
      const toast = await this.toastController.create({
        header: txtHeader,
        message: txtMessage,
        position: 'top',
        duration: 2000,
      });
      toast.present();
    } else {
      const toast = await this.toastController.create({
        header: txtHeader,
        message: txtMessage,
        position: 'top',
        duration: 2000,
        buttons: [
          {
            side: 'start',
            icon: 'star',
            text: 'Favorite',
            handler: () => {
              console.log('Favorite clicked');
            }
          }, {
            text: 'Done',
            role: 'cancel',
            handler: () => {
              console.log('Cancel clicked');
            }
          }
        ]
      });
      toast.present();
    }
  }

  async showAlertConfirm(headerTxt, messageTxt, typeIF, fromPage) {
    // console.log("aler: " + headerTxt, messageTxt, typeIF);
    const alert = await this.alertController.create({
      header: headerTxt,
      message: messageTxt,
      buttons: [
        {
          text: 'Okay',
          handler: () => {
            console.log("okay clicked  " + fromPage);
            if (fromPage === "approvals")
              this.events.publish('functionCall:tabApprovals', typeIF);
            else
              this.events.publish('functionCall:tabPoinfo', typeIF);
          }
        }, {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
        }
      ]
    });

    await alert.present();
  }

  compareDates(date1Year: any, date1Month: any, date1Day: any, date2Year: any, date2Month: any, date2Day: any): boolean {
    var date1 = new Date(date1Year, date1Month - 1, date1Day);
    var date2 = new Date(date2Year, date2Month - 1, date2Day);
    if (date2 > date1) {
      return true;
    } else
      return false;
  }

  validatePhone(value: any): boolean {
    let regExp = /^[0-9]{10}$/;
    // let regExp = /^\\(?([0-9]{3})\\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
    return this.validateRegEx(regExp, value.replace(/-/g, ''));
  }

  validateEmail(value: any): boolean {
    let regExp = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return this.validateRegEx(regExp, value);
  }

  validateZip(value: any): boolean {
    let regExp = /(^\\d{5}(-\\d{4})?$)|(^[ABCEGHJKLMNPRSTVXY]{1}\\d{1}[A-Z]{1} *\\d{1}[A-Z]{1}\\d{1}$)/;
    return this.validateRegEx(regExp, value);
  }

  validateRegEx(regExp: any, value: any): boolean {
    if (!regExp.test(value)) {
      return false;
    }
    return true;
  }

  validateMAPhoneNumber(value: any): boolean {
    if (/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(value)) {
      return true;
    }
  }

  validateMAPhone(value: any): boolean {
    if (/^\(?([2-9][0-9][0-9])\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/.test(value)) {
      return true;
    }
  }

  getCurrentDate() {
    var d = new Date();

    var month = d.getMonth() + 1;
    var day = d.getDate();

    var currentDate = d.getFullYear() + '/'
      + (('' + month).length < 2 ? '0' : '') + month + '/'
      + (('' + day).length < 2 ? '0' : '') + day;

    return currentDate;
  }

  getStatusImage(statusId: any) {
    var statusImg = null;
    if (statusId == '3') { // Saved
      statusImg = "assets/images/savedBtn.png";
    } else if (statusId == '4' || statusId == '14' || statusId == '12'
      || statusId == '13' || statusId == '15' || statusId == '16') {
      // Approved, Approved and Invoiced, Approved and Open, Approved and Part Invoiced, Approved and Received, Approved and Reimbursed

      statusImg = "assets/images/tickBtn.png";
    } else if (statusId == '1') {
      // Manager Review
      statusImg = "assets/images/managerRev.png";
    } else if (statusId == '6' || statusId == '5') {
      // Rejected by AP, Rejected by Manager
      statusImg = "assets/images/rejectedBtn.png";
    } else if (statusId == '2') {
      // AP Review
      statusImg = "assets/images/apreview_icon.png";
    } else if (statusId == '11') {
      // Cancelled
      statusImg = "assets/images/cancelled.png";
    } else if (statusId == '10') {
      // PreApprove and Forward
      statusImg = "assets/images/tickBtn.png";
    } else if (statusId == '7') {
      // PreApproved
      statusImg = "assets/images/tickBtn.png";
    } else if (statusId == '17') {
      // Parked
      statusImg = "assets/images/parkpo_mob_btn.png";
    }
    return statusImg;
  }

  setDateValue(dateValue: any) {
    if (typeof (dateValue) != "undefined") {
      if (dateValue.length > 0) {
        var item = dateValue.split("/");

        var dd = item[1];
        var mm = item[0];
        var yyyy = item[2];

        if (mm.length < 2) {
          mm = '0' + mm;
        }

        if (dd.length < 2) {
          dd = '0' + dd;
        }

        var trturnStr = yyyy + '-' + mm + '-' + dd;
        return trturnStr;
      }
    } else {
      return dateValue;
    }
  }

  splitDate(val: any) {
    if (val.length > 0) {
      var item = val.split("-");

      var dd = item[2];
      var mm = item[1];
      var yyyy = item[0];
      if (mm.length < 2) {
        mm = '0' + mm;
      }

      if (dd.length < 2) {
        dd = '0' + dd;
      }
      var trturnStr = mm + '/' + dd + '/' + yyyy;

      return trturnStr;
    }
  }

  presentLoading(showMessage: any) {
    let message = '';
    if (showMessage.length > 0) {
      message = showMessage;
    }

    let loader = this.loadingCtrl.create({
      message: message
    });
    // this.loader.present();
    return loader;
  }

  logOut() {
    window.localStorage["xmsusername"] = '';
    window.localStorage["xmspassword"] = '';

    return true;
  }

}
